import { type ConversationMetaResource } from './api/resources/messages'
import { type ConversationMeta } from './conversation-meta'

/**
 * Maps what a conversation is about.
 */
export function mapConversationMetaResourceToMeta(
  meta: ConversationMetaResource,
  conversationId: string | undefined,
): ConversationMeta {
  switch (meta.type as ConversationMeta['type']) {
    case 'Job': {
      if (!meta.id) {
        console.error(
          `Attempted parsing Job conversation meta, but no ID was present. Convo ID: ${conversationId}`,
        )
        return { type: 'Unknown' }
      }

      return {
        type: 'Job',
        name: meta.name || '<Unknown Job>',
        id: meta.id,
      }
    }
    default: {
      return { type: 'Unknown' }
    }
  }
}
